import { useEffect, useRef } from 'react';

const stats = [
  { icon: 'ri-map-pin-2-line', value: 'Todo o Brasil', label: 'Atendimento Nacional', desc: 'Clientes em todos os estados brasileiros, com suporte remoto completo.' },
  { icon: 'ri-scales-3-line', value: '98%', label: 'Taxa de Sucesso', desc: 'Especialistas em revisão e restituição de consórcios com alto índice de aprovação.' },
  { icon: 'ri-group-line', value: '1.200+', label: 'Clientes Atendidos', desc: 'Mais de mil famílias já recuperaram seus valores com nossa assessoria.' },
];

const depoimentos = [
  {
    nome: 'Marcos Oliveira',
    cidade: 'São Paulo, SP',
    texto: 'Não acreditava que conseguiria recuperar nada. Mas com a ajuda da equipe, recebi de volta R$ 18.400 do meu consórcio de imóvel. Recomendo muito!',
    stars: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%2040%20years%20old%20smiling%20portrait%20photo%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20casual%20shirt%2C%20high%20quality%20headshot&width=80&height=80&seq=dep001&orientation=squarish',
  },
  {
    nome: 'Ana Paula Ferreira',
    cidade: 'Belo Horizonte, MG',
    texto: 'Processo rápido e transparente. Em menos de 6 meses consegui a restituição do meu consórcio de automóvel. Equipe muito atenciosa e profissional.',
    stars: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%2035%20years%20old%20smiling%20portrait%20photo%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20casual%20blouse%2C%20high%20quality%20headshot&width=80&height=80&seq=dep002&orientation=squarish',
  },
  {
    nome: 'Roberto Santos',
    cidade: 'Curitiba, PR',
    texto: 'Tinha desistido do consórcio há 3 anos e não sabia que ainda tinha direito. Recuperei R$ 24.000! Serviço excelente, super recomendo.',
    stars: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%2050%20years%20old%20smiling%20portrait%20photo%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20polo%20shirt%2C%20high%20quality%20headshot&width=80&height=80&seq=dep003&orientation=squarish',
  },
];

export default function ProvasSocial() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.ps-anim').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="prova-social" className="py-20 md:py-28 bg-green-50" ref={sectionRef}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-green-600 font-semibold text-sm uppercase tracking-wider">Por Que Confiar em Nós</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4">
            Resultados Reais para Clientes Reais
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Somos especialistas em restituição de consórcios com histórico comprovado de sucesso em todo o Brasil.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {stats.map((s) => (
            <div
              key={s.label}
              className="ps-anim bg-white rounded-2xl p-7 border border-green-100 text-center"
              style={{ opacity: 0, transform: 'translateY(20px)', transition: 'opacity 0.5s ease, transform 0.5s ease' }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                <i className={`${s.icon} text-green-600 text-2xl`}></i>
              </div>
              <div className="text-3xl font-extrabold text-green-600 mb-1">{s.value}</div>
              <div className="font-bold text-gray-900 mb-2">{s.label}</div>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <h3 className="text-2xl font-extrabold text-gray-900 text-center mb-8">O Que Nossos Clientes Dizem</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {depoimentos.map((d) => (
            <div
              key={d.nome}
              className="ps-anim bg-white rounded-2xl p-6 border border-green-100"
              style={{ opacity: 0, transform: 'translateY(20px)', transition: 'opacity 0.5s ease, transform 0.5s ease' }}
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: d.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed italic mb-5">"{d.texto}"</p>
              <div className="flex items-center gap-3">
                <img
                  src={d.avatar}
                  alt={d.nome}
                  className="w-10 h-10 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="font-bold text-gray-900 text-sm">{d.nome}</div>
                  <div className="text-gray-400 text-xs">{d.cidade}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
